import * as AnomalyMessage from './anomaly';
import * as ContourMessage from './contour';

// Message format spec: https://docs.google.com/spreadsheets/d/1pjBspT545121sIvO1MKYxTuVv3muJ4sZDoeY3LIUW98
/**
 * Generate copy for an Alert.
 *
 * @param {Object} alert - the smart hub alert containing query and forecast information
 * @param {Object} options
 * @param {String} options.displayContext - determines which message to generate for a specific alert type
 * IN_REPORT, GLOBAL, or DASHBOARD
 * @param {String} options.subContext - specifies if only part of the message is required
 * @param {Boolean} options.typed - determines whether or not to display the report type before the message
 * @param {Number} [options.utcContext=0] - time offset in minutes for time localization
 *
 * @return {Object[]} - a list of tokens for each part of the message
 */
export function generateMessage(alert, {displayContext, subContext, typed, utcOffset = 0} = {}) {
  const {anomaly, contour} = alert;
  if (anomaly) {
    if (anomaly.insightsQuery) {
      return AnomalyMessage.generateInsightsMessage(anomaly, {displayContext, subContext, typed, utcOffset});
    } else if (anomaly.retentionQuery) {
      return AnomalyMessage.generateRetentionMessage(anomaly, {displayContext, subContext, typed, utcOffset});
    } else if (anomaly.funnelsQuery) {
      return AnomalyMessage.generateFunnelsMessage(anomaly, {displayContext, subContext, typed, utcOffset});
    }
  } else if (contour) {
    if (contour.insightsDetails) {
      return ContourMessage.generateInsightsMessage(contour, {displayContext, typed});
    } else if (contour.funnelsDetails) {
      return ContourMessage.generateFunnelsMessage(contour, {displayContext, typed});
    } else if (contour.retentionDetails) {
      return ContourMessage.generateRetentionMessage(contour, {displayContext, typed});
    }
  }
}
